import React, { useState, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as PersonPlus } from "bootstrap-icons/icons/person-plus.svg";
import { ReactComponent as PeopleFill } from "bootstrap-icons/icons/people-fill.svg";
import { ReactComponent as Trash } from "bootstrap-icons/icons/trash3.svg";
import { ReactComponent as BookmarkDash } from "bootstrap-icons/icons/bookmark-dash.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as CartFill } from "bootstrap-icons/icons/cart-fill.svg";
import { ReactComponent as PersonVcard } from "bootstrap-icons/icons/person-vcard.svg";
import { ReactComponent as Buildings } from "bootstrap-icons/icons/buildings.svg";
import { ReactComponent as BuildingsFill } from "bootstrap-icons/icons/buildings-fill.svg";
import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";

import { Link, useNavigate, useLocation } from "react-router-dom";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
} from "recharts";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import DashboardCards from "../../../components/DashboardCards";
import { toast } from "react-toastify";
import Spinner from "../../spinner/Spinner";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import BranchCard from "./BranchCard";
import ProductCard from "./ProductCard";
import { useBranchDashboard } from "../../../hooks/useAppData";

const SalesCards = ({ icon, Heading, Value }) => {
  return (
    <div>
      <div className="flex justify-between items-start  space-x-1 ">
        <img src={icon} alt="icon" height={30} width={30} />

        <h3 className="text-grey1 text-base">{Heading}</h3>
      </div>
      <h1 className="lg:text-2xl gilroy-bold w-full ml-2">{Value}</h1>
    </div>
  );
};
const BranchDashboard = () => {
  const [period, setPeriod] = useState("this_month");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [branchPage, setBranchPage] = useState(1);
  const [productPage, setProductPage] = useState(1);

  const navigate = useNavigate();

  const { permissions } = useContext(AuthContext);

  const hasPermission = (requiredPermission) => {
    if (!permissions || !Array.isArray(permissions)) {
      return false;
    }
    return permissions.some(permission => permission?.name === requiredPermission);
  };

  const canViewWallet = hasPermission('wallet.view');

  const dashFilters = {
    period,
    ...(period === "custom" && startDate ? { start_date: startDate } : {}),
    ...(period === "custom" && endDate ? { end_date: endDate } : {}),
  };

  const { data: dashResponse, isLoading: loading } = useBranchDashboard(dashFilters);
  const data = dashResponse?.data || null;

  // for branch card pagination
  const branchesPerPage = 8;

  const branchPaginate = (pageNumber) => setBranchPage(pageNumber);

  const branchHasPrevPage = () => branchPage > 1;

  const branchHasNextPage = () => {
    const totalBranches = data?.branches?.top_performing?.length || 0;
    return branchPage * branchesPerPage < totalBranches;
  };

  const currentBranches = data?.branches?.top_performing?.slice(
    (branchPage - 1) * branchesPerPage,
    branchPage * branchesPerPage
  ) || [];

  // for branch product
  const productsPerPage = 4;

  const productPaginate = (pageNumber) => setProductPage(pageNumber);

  const productHasPrevPage = () => productPage > 1;

  const productHasNextPage = () => {
    const totalProducts = data?.products?.top_products?.length || 0;
    return productPage * productsPerPage < totalProducts;
  };

  const currentProducts = data?.products?.top_products?.slice(
    (productPage - 1) * productsPerPage,
    productPage * productsPerPage
  ) || [];

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    // React Query auto re-fetches when dashFilters change via state updates
  };


  return (
    <div>
      <MainLayouts>
        {loading ? (
          <div className="flex justify-center items-center h-[80vh]">
            <Spinner loading={loading} />
          </div>
        ) : (
          <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
            <section className="container">
              <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                  <ol className="list-none p-0 inline-flex mb-2">

                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Overview
                      </p>
                      {/* <ChevronRightIcon /> */}
                    </li>
                    {/* <li className="flex items-center">
                    <p className="text-orange1">Dashbord</p>
                  </li> */}
                  </ol>
                </nav>
              </section>
              <form
                onSubmit={handleFilterSubmit}
                className="flex flex-wrap items-end gap-4 px-6 pt-4"
              >
                  <div>
                    <label className="block text-sm text-gray-700 mb-1">Period</label>
                    <select
                      value={period}
                      onChange={(e) => setPeriod(e.target.value)}
                      className="border border-grey3 p-2 rounded-md w-full md:w-48 py-3"
                    >
                      <option value="today">Today</option>
                      <option value="yesterday">Yesterday</option>
                      <option value="this_week">This Week</option>
                      <option value="last_week">Last Week</option>
                      <option value="this_month">This Month</option>
                      <option value="last_month">Last Month</option>
                      <option value="custom">Custom</option>
                    </select>
                  </div>

                {period === "custom" && (
                  <>
                    <div>
                      <label className="block text-sm text-gray-700 mb-1">
                        Start Date
                      </label>
                      <input
                        type="date"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        className="border border-grey3 p-2 rounded-md"
                        required
                      />
                    </div>
                    <div>
                      <label className="block text-sm text-gray-700 mb-1">
                        End Date
                      </label>
                      <input
                        type="date"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        className="border border-grey3 p-2 rounded-md"
                        required
                      />
                    </div>
                  </>
                )}

                <button
                  type="submit"
                  className="bg-darkGreen2 hover:bg-darkGreen2 text-lGrey px-4 py-3 rounded-md"
                >
                  Apply Filter
                </button>
              </form>


              <div className="px-6 pt-4 pb-2">
                {/* Top cards */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                  {canViewWallet && (
                    <DashboardCards
                      Heading="Revenue"
                      Icon={CashStack}
                      Amount={CurrencyFormatter(data?.overview?.total_revenue)}
                    />
                  )}

                  <Link to="/operations/branch/transaction/history">
                    <DashboardCards
                      Heading="Transactions"
                      Icon={PersonVcard}
                      Amount={data?.overview?.total_transactions}
                    />
                  </Link>
                  {/* <DashboardCards
                    Heading=" Customers"
                    Icon={PeopleFill}
                    Amount={data?.overview?.total_customers}
                  /> */}
                  <Link to="/operations/branch/list">
                    <DashboardCards
                      Heading="Active Branch"
                      Icon={Buildings}
                      Amount={data?.overview?.active_branches}
                    />
                  </Link>
                  <Link to="/operations/branch/reports">
                    <DashboardCards
                      Heading="Total Branch"
                      Icon={BuildingsFill}
                      Amount={data?.overview?.total_branches}
                    />
                  </Link>
                </div>
              </div>

            </section>
            {/* branch card */}
            <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
              <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                <ol className="list-none p-0 inline-flex mb-2">
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                      Top Branch  Performance
                    </p>
                  </li>
                </ol>
              </nav>
            </section>

            <BranchCard
              branches={currentBranches}
              currentPage={branchPage}
              paginate={branchPaginate}
              hasPrevPagep={branchHasPrevPage()}
              hasNextPagep={branchHasNextPage()}
            />


            {/* product card */}
            <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
              <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                <ol className="list-none p-0 inline-flex mb-2">
                  <li className="flex items-center">
                    <p className="text-blue-500 hover:text-blue-600 text-orange1 pr-2">
                      Product
                    </p>
                  </li>
                </ol>
              </nav>
            </section>

            <div className="px-6 pt-4 pb-2">
              {/* Top cards */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {canViewWallet && (
                  <DashboardCards
                    Heading="Total Product Sold"
                    Icon={CashStack}
                    Amount={data?.products?.total_products_sold}
                  />
                )}
                {canViewWallet && (
                  <DashboardCards
                    Heading="Category Sold"
                    Icon={PersonVcard}
                    Amount={data?.products?.categories_sold}
                  />
                )}
                {canViewWallet && (
                  <DashboardCards
                    Heading="Unique product Sold"
                    Icon={PersonVcard}
                    Amount={data?.products?.unique_products}
                  />
                )}
              </div>
            </div>

            <ProductCard
              products={currentProducts}
              currentPage={productPage}
              paginate={productPaginate}
            // hasPrevPage={productHasPrevPage()}
            // hasNextPage={productHasNextPage()}
            />

          </div>
        )}
      </MainLayouts>
    </div>
  );
};

export default BranchDashboard;
